<template>
  <!--   <v-container fluid>
    <v-layout>
      <h1>SignIn Page</h1>
    </v-layout>
  </v-container> -->
  <v-container
    fluid
    class="grey lighten-4 fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer />
            <!--             <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :href="source"
                  icon
                  large
                  target="_blank"
                  v-on="on"
                >
                  <v-icon>mdi-code-tags</v-icon>
                </v-btn>
              </template>
              <span>Source</span>
            </v-tooltip> -->
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Login"
                name="login"
                v-model="username"
                prepend-icon="person"
                type="text"
              />

              <v-text-field
                id="password"
                label="Password"
                name="password"
                v-model="password"
                prepend-icon="lock"
                type="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="tryLogin()"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>  
</template>


<script>

export default {
  name: 'SignIn',
  methods: {
    tryLogin() {
      var creds = {
        username: this.username,
        password: this.password
      }
      this.$store.dispatch("tryLogin", creds)
        .then(() => {
          // console.log(e);
          this.$router.replace('/recent');
        });
      
      var ret = true;
      return ret;
    }
  },
  data: () => ({
    username: '',
    password: '',
  })
};

</script>


<style scoped>
</style>
